import React, { useState } from 'react';
import type { TFunction } from 'i18next';
import U2000BasicDialog from '../../../u2000Core/components/dialog/U2000BasicDialog';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import { FaCheck, FaTimesCircle } from 'react-icons/fa';

interface U3203AiMissionRestoreDlgProps {
  isOpen: boolean;
  revisionNumber: number | null;
  restoring: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  t: TFunction;
  NS: string;
}

const U3203AiMissionRestoreDlg: React.FC<U3203AiMissionRestoreDlgProps> = ({
  isOpen,
  revisionNumber,
  restoring,
  onClose,
  onConfirm,
  t,
  NS,
}) => {
  const [comment, setComment] = useState('');

  if (!isOpen || revisionNumber === null) {
    return null;
  }

  const handleClose = () => {
    setComment('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(comment);
    setComment('');
  };

  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={() => handleClose()}
      title={t('lblRestoreDlgTitle', { ns: NS })}
      width="w-lg"
    >
      <div className="p-4">
        <p className="mb-4 text-sm text-gray-700">
          {t('msgRestoreRevision', { revisionNumber, ns: NS })}
        </p>
        <div>
          <label htmlFor="restoreComment" className="mb-1 block text-sm font-medium text-gray-700">
            {t('lblRestoreComment', { ns: NS })}
          </label>
          <textarea
            id="restoreComment"
            className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            maxLength={2000}
            disabled={restoring}
          />
        </div>
      </div>
      <div className="mt-2 flex justify-center gap-x-2 border-t-2 border-gray-300 p-4">
        <U2000ActionBtn
          label={t('dlgLblYes', { ns: 'translation' })}
          icon={FaCheck}
          handleClick={handleConfirm}
          disabled={restoring}
        />
        <U2000ActionBtn
          label={t('dlgLblNo', { ns: 'translation' })}
          icon={FaTimesCircle}
          handleClick={handleClose}
          disabled={restoring}
        />
      </div>
    </U2000BasicDialog>
  );
};

export default U3203AiMissionRestoreDlg;
